var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-topics",style:(_vm.containerStyle)},[_c('Transition',{attrs:{"name":_vm.transitionName,"mode":"out-in"}},[_c(_vm.topicGroupComponent,{tag:"Component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }